import ClearingAPI from '@shared/api';

export const {
    transferReports: { getCurrDay, getCurrDayById, getPrevDay, getPrevDayById },
} = ClearingAPI.settings;
